export const PermanentRedirectErrorCode = 301

export default class PermanentRedirectError extends Error {
  constructor(url = '/', host, e = 'Redirection permanente') {
    super(e)
    this.name = 'Moved Permamently'
    this.type = PermanentRedirectErrorCode
    this.url = url
    this.host = host
  }
}
